<script setup lang="ts">
import {dayjs, ElNotification, genFileId, UploadInstance, UploadRawFile} from "element-plus";
import {Md5} from "ts-md5";
import {ref} from "vue";
import {OrderService} from "@/api/api.ts";

const visible = ref<boolean>(false);

const upload = ref<UploadInstance>()
let courseId = 0;
const excelFile = ref<File>();
const excelName = ref<string>("");

const hide = () => {
  visible.value = false;
  excelFile.value = undefined;
  excelName.value = "";
};

const show = (_courseId: number) => {
  courseId = _courseId;
  visible.value = true;
};

const importFile = (e: any) => {
  excelName.value = e.file.name;
  excelFile.value = e.file;
};

const emit = defineEmits(["onAddSuccess"]);

const onSubmit = async() => {
  if (!excelFile.value) {
    return ElNotification.error({
      message: "请选择文件",
    })
  }
  try {
    const formData = new FormData();
    formData.append("file", excelFile.value as Blob);
    formData.append("course_id", courseId.toString());
    formData.append("key", Md5.hashStr("微同课" + dayjs().format("YYYY-MM-DD HH:mm")))
    const res = await OrderService.batchAddCourseApply(formData)
    if (res.data.code === 200) {
      ElNotification.success({
        title: "批量添加成功",
        message: res.data.msg,
      })
      hide()
      emit("onAddSuccess")
    } else {
      ElNotification.error({
        message: res.data.msg,
      })
    }
  } catch (e) {
    console.warn(e);
  }
};

const onExceed = (files: any) => {
  upload.value!.clearFiles()
  const file = files[0] as UploadRawFile
  file.uid = genFileId()
  upload.value!.handleStart(file)
  excelName.value = file.name;
  excelFile.value = file;
}

defineExpose({hide, show});
</script>

<template>
  <el-dialog v-model="visible" title="批量添加学员" align-center>
    <el-upload
        ref="upload"
        :multiple="false"
        :show-file-list="true"
        :http-request="importFile"
        :on-exceed="onExceed"
        :limit="1"
        accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
      <template #trigger>
        <el-button type="primary">选择文件</el-button>
      </template>
    </el-upload>
    <a href="https://view.bioquan.com/%E6%B7%BB%E5%8A%A0%E5%AD%A6%E5%91%98%E6%A0%B7%E5%BC%8F.xlsx">下载模板文件</a>
    <div class="text-red mt-16px">批量上传仅支持300人以内</div>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="hide">取消</el-button>
        <el-button type="primary" @click="onSubmit">
          确认上传
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>
</style>
